module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-account-setup"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.account_setup.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-account-setup__main"
  }, [(_vm.setupSuccess) ? _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.account_setup.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('div', {
    staticClass: "u-paragraph s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.setup.text)
    }
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "primary_email"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.primary_email_label')) + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.primary_email),
      expression: "request.primary_email"
    }],
    attrs: {
      "id": "primary_email",
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.request.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "primary_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [(_vm.showLocales) ? _c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "locale"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.locale_label')) + "*\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showLocales) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.locale),
      expression: "request.locale"
    }],
    class: {
      'is-not-valid': _vm.errors.last_name
    },
    attrs: {
      "id": "locale",
      "text": "Select locale",
      "name": "locale"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.request, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      key: locale.locale,
      domProps: {
        "value": locale.locale
      }
    }, [_vm._v("\n                " + _vm._s(locale.name) + "\n              ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.new_password_label')) + " *\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "u-tiny-list"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('web.account_setup.new_password_minimum_12_characters')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.account_setup.new_password_minimum_1_number')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.reset_password.new_password_minimum_1_symbol')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('web.account_setup.new_password_minimum_1_uppercase')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password),
      expression: "request.password"
    }],
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "",
      "name": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.password), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "password_confirmation"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.account_setup.confirm_new_password_label')) + " *\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.password_confirmation),
      expression: "request.password_confirmation"
    }],
    attrs: {
      "id": "password_confirmation",
      "type": "password",
      "placeholder": "",
      "name": "password_confirmation",
      "required": ""
    },
    domProps: {
      "value": (_vm.request.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "password_confirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.password_confirmation), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _vm._l((_vm.setup.fields), function(field) {
    return [_c('fieldset', {
      key: field.name,
      staticClass: "o-fieldset c-card--submit-claim__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      staticClass: "u-label",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "name": field.name
      },
      model: {
        value: (_vm.request[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.request, field.name, $$v)
        },
        expression: "request[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', {
        key: error
      }, [_c('div', {
        staticClass: "c-validation t-alert-danger"
      }, [_vm._v(_vm._s(error))])])
    })], 2)]
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('div', {
    staticClass: "o-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.terms_and_conditions),
      expression: "request.terms_and_conditions"
    }],
    class: 'o-checkbox__input',
    attrs: {
      "id": "terms_and_conditions",
      "type": "checkbox",
      "name": "terms_and_conditions",
      "required": ""
    },
    domProps: {
      "checked": _vm.request.terms_and_conditions ? 'checked' : '',
      "checked": Array.isArray(_vm.request.terms_and_conditions) ? _vm._i(_vm.request.terms_and_conditions, null) > -1 : (_vm.request.terms_and_conditions)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.request.terms_and_conditions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.request, "terms_and_conditions", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.request, "terms_and_conditions", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.request, "terms_and_conditions", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i18n', {
    staticClass: "o-checkbox__label",
    attrs: {
      "path": "web.account_setup.accept_terms",
      "tag": "label"
    },
    scopedSlots: _vm._u([{
      key: "terms_link",
      fn: function() {
        return [_c('a', {
          staticClass: "t-link",
          attrs: {
            "href": _vm.setup.terms_link,
            "target": "_blank"
          },
          on: {
            "click": function($event) {
              return _vm.openLink($event)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.$t('web.account_setup.accept_terms_link')) + "\n                    ")])]
      },
      proxy: true
    }], null, false, 3641884939)
  }), _vm._v(" "), _vm._l((_vm.errors.terms_and_conditions), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger u-round-corners"
    }, [_vm._v(_vm._s(error))])])
  })], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('button', {
    staticClass: "c-button c-button--full-width t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.account_setup.signup_button')) + "\n          ")])])])]) : _vm._e(), _vm._v(" "), (!_vm.setupSuccess) ? _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('div', {
    staticClass: "c-card__inner"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.account_setup.error_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('p', {
    staticClass: "c-card__paragraph"
  }, [_vm._v(_vm._s(_vm.setupSuccessMessage))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [(_vm.codeResponse === 'user.setup') ? _c('router-link', {
    staticClass: "c-card__footer__text-link u-tiny-note u-float-left t-link",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.account_setup.error_login_link')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.codeResponse === 'user.token') ? _c('button', {
    staticClass: "c-button c-button--full-width t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.resend($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.account_setup.resend_setup_email_button')) + "\n          ")]) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b017b480"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AccountSetup.vue
// module id = 563
// module chunks = 1